import { TypedAnalyticsEvent } from "@omni/types/components/tracking/analyticsEvent";
import { EventType } from "@omni/types/components/tracking/eventType.enum";
import { AvailableInStoreTrackingInfo } from "@omni/types/components/tracking/tracking-info/feature/availableInStore.trackingInfo";

import { getPageInfo, getUserInfo } from "@/services/tracking/trackers/utils";
import * as TrackingService from "@/services/tracking/tracking.service";

export const track = (trackingInfo: AvailableInStoreTrackingInfo) => {
    const event: TypedAnalyticsEvent<AvailableInStoreTrackingInfo> = {
        event: EventType.AvailableInStore,
        payload: {
            eventData: trackingInfo,
            pageInfo: getPageInfo(),
            userInfo: getUserInfo()
        }
    };

    TrackingService.track(event);
};

export const trackOn = (storeId?: string) => {
    track({
        on: true,
        name: "Toggle voorkeurswinkel aan",
        storeId: storeId
    });
};

export const trackOff = (storeId?: string) => {
    track({
        on: false,
        name: "Toggle voorkeurswinkel uit",
        storeId: storeId
    });
};
